import React from 'react'

const SchedaCopiataContext = React.createContext()

export default SchedaCopiataContext
